module.exports = __webpack_public_path__ + "media/img/payment-methods/security-code-f12dc630385b0fda80f18dbc6fe87781.svg";